export const SET_CUSTOM_FIELDS = 'SET_CUSTOM_FIELDS';

export const setCustomFields = (fields) => ({
  type: SET_CUSTOM_FIELDS,
  payload: fields,
});
